import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, ModelSignal } from '@angular/core';
import { IPHXOutputComponent } from '../../../../@core/interfaces/IPHXOutputComponent.interface';
import { Task } from '../../../../generated/generated-types';

@Component({
    selector: 'app-task-title-column-widget',
    templateUrl: './task-title-column-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule]
})
export class TaskTitleColumnWidgetComponent implements IPHXOutputComponent {

    model: Task;
    modelSig?: ModelSignal<Task>;
    args: any;
    change: any;

    get task(): Task | null {
        return this.modelSig ? this.modelSig() : this.model;
    }

    isCompleted = computed(() => {
        return this.task?.status === 'COMPLETED';
    });

    get title(): string {
        return this.task?.title || '';
    }

}
